///Testimonial Slider
$(".testimonials-slider").slick({
 slidesToShow: 2,
 infinite:true,
 slidesToScroll: 1,
 // autoplay: true,
 // autoplaySpeed: 4000,
  arrow: true,
  dots: true,
  responsive: [
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 1
      }
    },
    ]
});

//Product Page Tab
$(document).ready(function(){
    $('ul.shopify-tabs > li').click(function(){
      var tab_id = $(this).attr('data-tab');

      $(this).parent().find('li').removeClass('current');
      $('.shopify-tab-content').removeClass('current');

      $(this).addClass('current');
      $("#"+tab_id).addClass('current');
    })
});

// Fancybox Config
$('[data-fancybox="gallery"]').fancybox({
  buttons: [
    "slideShow",
    "thumbs",
    "zoom",
    "close"
  ],
  loop: false,
  protect: true
});



